import MenuDesktop from "./../MenuDesktop";
import MegaMenu from "./../megaMenu";

document.addEventListener("DOMContentLoaded", () => {
    const mainNavigation = document.querySelector(".js-navigation");
    if (mainNavigation !== null) {
        new MenuDesktop(mainNavigation);

        let mega = mainNavigation.querySelectorAll(
            ":scope > .menu-item.menu-item-has-children",
        );
        if (mega.length > 0) {
            mega.forEach((m) => {
                new MegaMenu(m);
            });
        }
    }

    let previous_scroll = 0;
    let header = document.querySelector(".js-header");
    if (header !== null) {
        let top = header.querySelector(".header__top");
        let top_height = top.offsetHeight;
        header.style.setProperty("--height", -(top_height + 3) + "px");
        window.addEventListener("scroll", () => {
            let st = window.pageYOffset || document.documentElement.scrollTop;
            if (st <= 0) {
                if (header.classList.contains("fixed")) {
                    header.classList.remove("fixed");
                }
                if (header.classList.contains("scrolled")) {
                    header.classList.remove("scrolled");
                }
            }
            if (st > previous_scroll) {
                if (header.classList.contains("fixed")) {
                    header.classList.remove("fixed");
                }
                if (st > header.offsetHeight) {
                    if (!header.classList.contains("scrolled")) {
                        header.classList.add("scrolled");
                    }
                }
            } else if (st < previous_scroll) {
                if (st > header.offsetHeight) {
                    if (!header.classList.contains("fixed")) {
                        header.classList.add("fixed");
                    }
                }
            }
            previous_scroll = st <= 0 ? 0 : st;
        });
    }
});
